(() => {
  const names = {
    es: 'Español', en: 'English', de: 'Deutsch', fr: 'Français',
    it: 'Italiano', 'pt-pt': 'Português', pt: 'Português',
    nl: 'Nederlands', pl: 'Polski', ro: 'Română', cs: 'Čeština'
  };
  let originalAnchor;

  function placeForViewport(widget) {
    const mobileMenu = document.querySelector('.main-menu__content');
    const isMobile = window.matchMedia('(max-width: 768.98px)').matches;
    if (isMobile && mobileMenu) {
      if (!originalAnchor) {
        originalAnchor = document.createComment('langshop-anchor');
        widget.parentNode?.insertBefore(originalAnchor, widget);
      }
      if (widget.parentElement !== mobileMenu) mobileMenu.prepend(widget);
    } else if (originalAnchor?.parentNode && widget.parentElement !== originalAnchor.parentNode) {
      originalAnchor.parentNode.insertBefore(widget, originalAnchor.nextSibling);
    }
  }

  function enhance() {
    const widget = document.querySelector('.lsn-switcher');
    if (!widget) return;
    placeForViewport(widget);
    const current = widget.querySelector('.lsn-select__current');
    const list = widget.querySelector('.lsn-select__list');
    if (!current || !list) return;

    const currentName = current.querySelector('.lsn-select__item-name');
    const visibleCode = (currentName?.textContent || '').trim().toLowerCase();
    const selectedCode = (widget.querySelector('.lsn-select__input')?.value ||
      (names[visibleCode] ? visibleCode : current.dataset.languageCode || visibleCode)).trim().toLowerCase();
    if (names[selectedCode]) current.dataset.languageCode = selectedCode;
    if (currentName && names[selectedCode] && currentName.textContent !== names[selectedCode]) {
      currentName.textContent = names[selectedCode];
    }
    for (const item of list.querySelectorAll('.lsn-select__item')) {
      const code = (item.dataset.value || '').toLowerCase();
      const label = item.querySelector('.lsn-select__item-name');
      if (label && names[code] && label.textContent !== names[code]) label.textContent = names[code];
      if (names[code]) item.setAttribute('aria-label', names[code]);
      if (code === selectedCode) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    }
    current.setAttribute('role', 'button');
    current.setAttribute('tabindex', '0');
    current.setAttribute('aria-label', 'Select language');
    current.setAttribute('aria-expanded', String(current.classList.contains('lsn-show')));
    if (!current.dataset.enhancedKeyboard) {
      current.dataset.enhancedKeyboard = 'true';
      current.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          current.click();
        } else if (event.key === 'Escape' && current.classList.contains('lsn-show')) {
          current.click();
        }
      });
    }
  }

  function start() {
    let queued = false;
    const refresh = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; enhance(); });
    };
    refresh();
    new MutationObserver(refresh).observe(document.documentElement, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['class', 'data-value', 'value']
    });
    let attempts = 0;
    const timer = setInterval(() => {
      refresh();
      attempts += 1;
      if (attempts >= 30) clearInterval(timer);
    }, 500);
    window.addEventListener('resize', refresh, { passive: true });
  }

  start();
})();
